var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("Sorry, the page you are looking for does not exist.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }